import { create } from 'zustand';

interface DemoStore {
  isDemoMode: boolean;
  setDemoMode: (value: boolean) => void;
}

/**
 * Global flag indicating whether the app is running in demo mode.
 * Used by AppLayout to render DemoBanner, and by DemoPage to mark/unmark demo state.
 * Lives in shared/ so both AppLayout (shared) and DemoPage (features/demo) can import it.
 */
export const useDemoStore = create<DemoStore>()((set) => ({
  isDemoMode: false,
  setDemoMode: (value) => set({ isDemoMode: value }),
}));
